module.exports = __webpack_public_path__ + "static/media/1empty.2f0f4d0b.png";